import React, { useEffect } from 'react'
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import $ from "jquery";

const Sidebar = ({ icon }) => {
    const navigate = useNavigate();

    useEffect(() => {
        axios.get("/auth").then((res) => {
            if (!res.data) {
                navigate('/login')
            }
        });
    }, []);

    return (
        <nav className="sidebar">
            <div className="sidebar-header">
                <Link to="/" className="sidebar-brand">
                    Best<span>Feed</span>IQ
                </Link>
                <div className="sidebar-toggler not-active" onClick={() => {
                    $('.sidebar-header .sidebar-toggler').toggleClass('active not-active');
                    if (window.matchMedia('(min-width: 992px)').matches) {
                        $('body').toggleClass('sidebar-folded');
                    } else if (window.matchMedia('(max-width: 991px)').matches) {
                        $('body').toggleClass('sidebar-open');
                    }
                    $(".sidebar .sidebar-body").on('hover', () => {
                        if ($('body').hasClass('sidebar-folded')) {
                            $('body').addClass("open-sidebar-folded");
                        }
                    }, () => {
                        if ($('body').hasClass('sidebar-folded')) {
                            $('body').removeClass("open-sidebar-folded");
                        }
                    });
                }}>
                    <span />
                    <span />
                    <span />
                </div>
            </div>
            <div className="sidebar-body">
                <ul className="nav">
                    <li className="nav-item nav-category">Main</li>
                    <li className="nav-item">
                        <Link to="/products" className="nav-link">
                            <icon.Layers className="link-icon" />
                            <span className="link-title">Products</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/activities" className="nav-link">
                            <icon.Image className="link-icon" />
                            <span className="link-title">Activity</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/clients" className="nav-link">
                            <icon.Flag className="link-icon" />
                            <span className="link-title">Clients</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/staffs" className="nav-link">
                            <icon.Users className="link-icon" />
                            <span className="link-title">Staff</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/why-us" className="nav-link">
                            <icon.Crosshair className="link-icon" />
                            <span className="link-title">Why Us?</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/our-vision" className="nav-link">
                            <icon.Eye className="link-icon" />
                            <span className="link-title">Our Vision</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/about-us" className="nav-link">
                            <icon.Eye className="link-icon" />
                            <span className="link-title">About</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/slides" className="nav-link">
                            <icon.Image className="link-icon" />
                            <span className="link-title">Slides</span>
                        </Link>
                    </li>
                    <li className="nav-item nav-category">General</li>
                    <li className="nav-item">
                        <Link to="/users" className="nav-link">
                            <icon.User className="link-icon" />
                            <span className="link-title">Users</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/socials" className="nav-link">
                            <icon.Link2 className="link-icon" />
                            <span className="link-title">Social</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/settings" className="nav-link">
                            <icon.Settings className="link-icon" />
                            <span className="link-title">Settings</span>
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/offices" className="nav-link">
                            <icon.Flag className="link-icon" />
                            <span className="link-title">Office</span>
                        </Link>
                    </li>
                </ul>
            </div>
        </nav >
    );
}

export default Sidebar;